import { render, staticRenderFns } from "./UserOtherTab.vue?vue&type=template&id=d93aeda4&scoped=true"
import script from "./UserOtherTab.vue?vue&type=script&lang=js"
export * from "./UserOtherTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d93aeda4",
  null
  
)

export default component.exports